(angular => {
  "use strict";

  angular.module("FindRetailerNotBussinesClub")
    .controller("FindRetailerNotBussinesClub.IndexCtrl", [
      "$scope",
      "$timeout",
      "$mdDialog",
      "$q",
      "Loader",
      "Toast",
      "AuthService",
      "ActivityService",
      "FindRetailerNotBussinesClubService",
      IndexCtrl
    ]);

  function IndexCtrl($scope, $timeout, $mdDialog, $q, Loader, Toast, authService, ActivityService, FindRetailerNotBussinesClubService) {
    this.user = authService.getTokenData();
    this.promise = null;
    this.query = { orderBy: "name" };
    this.pagination = { page: 1, limit: 10 };
    this.participants = [];
    this.activities = [];
    this.statusSelected = '';
    this.all = false;
    this.status = ['Selecionado', 'Não Selecionado'];
    let queryTimeout;

    this.loadParticipants = () => {
      return this.promise = $q.all([
        ActivityService.findActivityByEvent(this.user.eventId, this.user.companyIds[0]),
        FindRetailerNotBussinesClubService.listForNotBussinessClub(this.user.eventId, this.user.companyIds[0], this.query.orderBy)
      ]).then(([activities, participants]) => {
        if (activities.length > 0) {
          this.activities = activities;
          this.participants = this.selectList(activities, this.filterQuery(participants));
          this.filterStatus();
        } else {
          Toast.show('Sua empresa não possui nenhuma atividade agendada', 'error');
        }
      }).catch(err => Toast.httpHandler(err));
    };

    this.selectList = (activities, participants) => {
      participants.forEach(p => {
        p.selected = false;
      });

      const selectedRestricted = activities[0].restricted_list.filter(rl => rl.status === 'SELECIONADO');

      selectedRestricted.forEach(rl => {
        participants.forEach(p => {
          if (rl.cpf && p.cpf && rl.cpf.toUpperCase() === p.cpf.toUpperCase()) {
            p.selected = true;
          }
        });
      });

      return participants;
    };

    this.filterQuery = (participants) => {
      const query = angular.copy(this.search);
      if (query) {
        return participants.filter(p =>
          p.name.toUpperCase().indexOf(query.toUpperCase()) > -1 ||
          (p.position && p.position.toUpperCase().indexOf(query.toUpperCase()) > -1)
        );
      }
      return participants;
    };

    this.filterStatus = () => {
      if (this.statusSelected === 'Selecionado') {
        this.participants = this.participants.filter(p => p.selected === true);
      } else if (this.statusSelected === 'Não Selecionado') {
        this.participants = this.participants.filter(p => p.selected === false);
      }
    };

    this.toogleAll = () => {
      if (!this.all) {
        this.participants.forEach(p => { p.selected = true; });
        this.all = true;
      } else {
        this.participants.forEach(p => { p.selected = false; });
        this.all = false;
      }
    };

    this.addRestrictedList = () => {
      queryTimeout = $timeout(() => {
        const participantRestricted = this.participants.map(val => ({
          activity_id: this.activities[0].id,
          company_name: val.company ? val.company.name : '',
          company_id: val.company ? val.company.id : null,
          name: val.name,
          cpf: val.cpf,
          status: val.selected ? 'SELECIONADO' : '',
          selection_source: val.selected ? 'Usuário Parceiro' : '',
          status_participant: 1,
        }));

        this.activities[0].restricted_list = participantRestricted;
        const model = angular.copy(this.activities[0]);

        return Loader.add(ActivityService.saveRestrictedList(model))
          .then(result => {
            $mdDialog.hide(result);

            if (!result.importationResult || !result.importationResult.errors.length) {
              this.loadParticipants();
              Toast.show('Adicionado com sucesso', 'success');
              return;
            }

            const participants = result.importationResult.errors.map(data => {
              const errors = {
                'participant-not-found': 'O participante não está inscrito no evento',
                'participant-associated': 'O participante não é um associado dessa rede',
                'participant-duplicated': 'O cpf já foi inserido',
                'Nonexistent-company': 'Essa Empresa não está cadastrada',
              };
              data.participant.error = errors[data.error] || data.error;
              return data.participant;
            });

            $mdDialog.show({
              templateUrl: 'admin/activity/import/import.html',
              controller: 'Activity.ImportCtrl',
              controllerAs: '$ctrl',
              clickOutsideToClose: true,
              escapeToClose: true,
              fullscreen: true,
              locals: { participants },
            });
          })
          .catch(err => Toast.httpHandler(err));
      }, 500);
    };

    this.isChecked = () => {
      return this.participants.filter(p => p.selected).length === this.participants.length;
    };

    $scope.$watch(() => this.query, () => {
      $timeout.cancel(queryTimeout);
      queryTimeout = $timeout(() => {
        this.pagination.page = 1;
        this.loadParticipants();
      }, 500);
    }, true);

    $scope.$watch(() => this.search, () => {
      $timeout.cancel(queryTimeout);
      queryTimeout = $timeout(() => {
        this.pagination.page = 1;
        this.loadParticipants();
      });
    });

    $scope.$watch(() => this.statusSelected, () => {
      $timeout.cancel(queryTimeout);
      queryTimeout = $timeout(() => {
        this.pagination.page = 1;
        this.loadParticipants();
      }, 500);
    }, true);

    this.loadParticipants();
  }
})(angular || {});
